import type { ExportRequest } from '@/lib/export-request'

/**
 * AP-35 Nachtrag 9 — der Auftrag als `ExportRequest`: `GET …/export` lädt das
 * PDF, `POST …/export/mail` sendet dieselbe Datei (`.claude/rules/export-per-mail.md`).
 * Drucken und Senden setzen die Schritte auf „zugeteilt“.
 *
 * - `stepId`: der Auftrag eines Schritts;
 * - sonst die Aufträge aller freigegebenen Schritte des Projekts, mit
 *   `positionId` nur dieser Position.
 */
export function workOrderExportRequest(o: { projectId: string; positionId?: string | null; stepId?: string | null }): ExportRequest {
  if (o.stepId) return { url: `/projects/work-steps/${o.stepId}/work-order/export`, params: {} }
  return { url: `/projects/${o.projectId}/work-orders/export`, params: o.positionId ? { positionIds: o.positionId } : {} }
}
